export default __webpack_public_path__ + "static/media/6.85913d42.png";